import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Stack,
  IconButton,
  Tooltip
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const BackendCallDialog = ({ 
  open, 
  onClose, 
  title = "Backend Call Details", 
  apiCall, 
  maxWidth = "md" 
}) => {
  const [copied, setCopied] = useState(false);
  const endpoint = apiCall?.endpoint || '';
  const payload = apiCall?.payload || null;

  const payloadText = payload ? JSON.stringify(payload, null, 2) : '';

  const handleCopyPayload = async () => {
    if (!payloadText) return;
    try {
      await navigator.clipboard.writeText(payloadText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 1 }}>
          {/* Endpoint Section */}
          <Box>
            <Typography variant="subtitle2" color="primary" gutterBottom>
              Endpoint
            </Typography>
            <Box 
              component="pre" 
              sx={{ 
                backgroundColor: '#f5f5f5', 
                p: 2, 
                borderRadius: 1, 
                overflow: 'auto',
                fontSize: '0.875rem',
                fontFamily: 'monospace',
                maxHeight: '10vh',
                margin: 0
              }}
            >
              {endpoint || 'No endpoint available'}
            </Box>
          </Box>

          {/* Payload Section */}
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
              <Typography variant="subtitle2" color="primary" gutterBottom sx={{ mb: 0 }}>
                Payload
              </Typography>
              <Tooltip title={copied ? 'Copied!' : 'Copy to clipboard'}>
                <span>
                  <IconButton
                    size="small"
                    onClick={handleCopyPayload}
                    disabled={!payloadText}
                    aria-label="Copy payload"
                  >
                    <ContentCopyIcon fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            </Box>
            <Box 
              component="pre" 
              sx={{ 
                backgroundColor: '#f5f5f5', 
                p: 2, 
                borderRadius: 1, 
                overflow: 'auto',
                fontSize: '0.875rem',
                fontFamily: 'monospace',
                maxHeight: '50vh',
                margin: 0
              }}
            >
              {payloadText || 'No payload available'}
            </Box>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default BackendCallDialog;
